import { IconProps, NocIconGenerator } from '../common';

export const MouseSquare = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'MouseSquare',
            path: (
                <>
                    <path
                        d="M22 12V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H12"
                        stroke="#292d32"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M20.96 17.8405L19.33 18.3905C18.88 18.5405 18.52 18.8905 18.37 19.3505L17.82 20.9805C17.35 22.3905 15.37 22.3605 14.93 20.9505L13.08 15.0005C12.72 13.8205 13.81 12.7205 14.98 13.0905L20.94 14.9405C22.34 15.3805 22.36 17.3705 20.96 17.8405Z"
                        stroke="#292d32"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </>
            ),
        }}
    />
);
